export const UI = {
  classes: {
    MULTIPLE_MODALS_OPEN: 'multiple-modals-open',
    CONFIRMATION_OPEN: 'confirmation-open',
    HELP_OPEN: 'help-open',
    INPUT_LOCKED: 'input-locked',
  }
}
